import React from 'react';
import './RangeDisplay.css'; // Import CSS for styling

const RANKS = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2'];

interface RangeDisplayProps {
  range: Set<string>; // Accept the set of hands to display
}

// Helper function (can be kept or moved to a utils file)
const getHandString = (rank1: string, rank2: string, suited: boolean) => {
  const r1idx = RANKS.indexOf(rank1);
  const r2idx = RANKS.indexOf(rank2);
  if (r1idx === r2idx) return `${rank1}${rank2}`; // Pair
  if (r1idx < r2idx) return suited ? `${rank1}${rank2}s` : `${rank1}${rank2}o`;
  return suited ? `${rank2}${rank1}s` : `${rank2}${rank1}o`;
};

export const RangeDisplay: React.FC<RangeDisplayProps> = ({ range }) => {

  // No state or interaction needed for display

  return (
    // Root scoping class
    <div className="range-display-component"> 
      <div className="range-grid"> 
        {/* Corner element removed */}
        {/* <div className="range-corner" /> */}

        {/* Render column headers directly */}
        {/* Need an empty cell placeholder for grid alignment if corner removed */}
        <div /> 
        {RANKS.map(rank => (
          <div key={`col-${rank}`} className="range-header">{rank}</div>
        ))}

        {/* Render row headers and cells directly */}
        {RANKS.map((rank1, i) => (
          <React.Fragment key={`row-frag-${rank1}`}>
            {/* Row Header */}
            <div key={`row-head-${rank1}`} className="range-header">{rank1}</div>
            {/* Cells for this row */}
            {RANKS.map((rank2, j) => {
              const isPair = i === j;
              const isSuited = i > j;
              const hand = getHandString(rank1, rank2, isSuited);
              const isSelected = range.has(hand);
              return (
                <div
                  key={`${rank1}${rank2}${isPair ? '' : (isSuited ? 's' : 'o')}`}
                  className={`range-cell ${isSelected ? 'selected' : ''} ${isPair ? 'pair' : isSuited ? 'suited' : 'offsuit'}`}
                  title={hand} 
                >
                  {hand}
                </div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}; 